// components
import WhenSection from '../WhenSection/WhenSection';
import WhatWhereSection from '../WhatWhereSection/WhatWhereSection';
import CommentSection from '../CommentSection/CommentSection';
import EntitySection from '../EntitySection/EntitySection';

// styles
import { FormContentGrid, FormWrapper } from './FormInputSection.styles';

// types
import type { RefObject } from 'react';

type FormInputSectionProps = {
  activityFieldRef?: RefObject<HTMLInputElement | null>;
  timeFieldRef?: RefObject<HTMLInputElement | null>;
};

const FormInputSection = ({
  activityFieldRef,
  timeFieldRef
}: FormInputSectionProps) => {
  'use memo';
  return (
    <FormWrapper>
      <FormContentGrid>
        <WhenSection timeFieldRef={timeFieldRef} />
        <WhatWhereSection activityFieldRef={activityFieldRef} />

        <EntitySection planningEntityType="EMPLOYEE" />
        <EntitySection planningEntityType="CLIENT" />
        <EntitySection planningEntityType="RESOURCE" />

        <CommentSection />
      </FormContentGrid>
    </FormWrapper>
  );
};

export default FormInputSection;
